import { backend, domain } from 'modules/data';

export interface Row {
    id: string;
    workflowId?: string;
    requestId: string;
    name: string;
    step: string;
    replacementEmail?: string;
    role?: backend.ParticipantRole;
    amount?: string;
    currency?: string;
    required: boolean;
    companyId: string;
}

export const GLOBAL_USER_REPLACEMENT = 'GLOBAL_USER_REPLACEMENT';

export enum RequestReplacementMode {
    OneForAll = 'OneForAll',
    Each = 'Each',
}

export enum OffbardingStep {
    First = 1,
    Second = 2,
}

export interface OffboardUserInfoAnswer {
    requests: domain.RequestsParticipant[];
    workflows: domain.WorkflowsParticipant[];
}
